import { Component, Input, Output, EventEmitter } from "@angular/core";
import { EmpresaService } from "../../../../shared/services/empresa.service";

@Component({
  selector: "app-empresa-detalhe-modal",
  templateUrl: "./empresa-detalhe-modal.component.html",
  styleUrls: ["./empresa-detalhe-modal.component.scss"],
})
export class EmpresaDetalheModalComponent {
  @Input() empresa: any;
  @Input() aberto: boolean = false;
  @Output() fechar = new EventEmitter<void>();

  editandoStatus = false;
  novoStatus: string;

  constructor(private empresaService: EmpresaService) {}

  abrirEdicaoStatus() {
    this.novoStatus = this.empresa.status;
    this.editandoStatus = true;
  }

  salvarStatus() {
    this.empresaService
      .updateStatusEmpresa(this.empresa.id, this.novoStatus)
      .subscribe({
        next: (res) => {
          this.empresa.status = this.novoStatus;
          this.editandoStatus = false;
        },
        error: () => {
          this.editandoStatus = false;
        },
      });
  }

  get planoStatus() {
    if (!this.empresa?.plano?.expiracao)
      return { status: "indefinido", dias: null };
    const hoje = new Date();
    const expira = new Date(this.empresa.plano.expiracao);
    const diff = Math.ceil(
      (expira.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (diff > 7) return { status: "ativo", dias: diff };
    if (diff >= 0) return { status: "expirando", dias: diff };
    return { status: "expirado", dias: diff };
  }

  get planoStatusLabel() {
    const s = this.planoStatus.status;
    if (s === "ativo") return "Ativo";
    if (s === "expirando") return "Expirando";
    if (s === "expirado") return "Expirado";
    return "Indefinido";
  }

  get planoStatusClass() {
    const s = this.planoStatus.status;
    if (s === "ativo") return "badge-status badge-ativo";
    if (s === "expirando") return "badge-status badge-expirando";
    if (s === "expirado") return "badge-status badge-expirado";
    return "badge-status badge-indefinido";
  }

  get diasRestantesTexto() {
    const dias = this.planoStatus.dias;
    if (dias == null) return "";
    if (dias > 1) return `Faltam ${dias} dias para expirar`;
    if (dias === 1) return "Falta 1 dia para expirar";
    if (dias === 0) return "Expira hoje";
    if (dias < 0) return `Expirado há ${Math.abs(dias)} dias`;
    return "";
  }

  get valorComissao(): string {
    const valorPlano = parseFloat(this.empresa?.plano?.valor || "0");
    const comissao = parseFloat(this.empresa?.comissao_representante || "0");
    if (isNaN(valorPlano) || isNaN(comissao)) return "-";
    const valor = (valorPlano * comissao) / 100;
    return valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  fecharModal() {
    this.fechar.emit();
  }
}
